import type { DatesRangeValue, DateValue, DayProps } from '@mantine/dates'
import type { FocusEvent, ReactNode } from 'react'
import type { ColorPalette } from '../../types/color-palette.types'

export interface DatePickerProps {
  fieldName: string
  placeholder: string
  value?: DateValue | Date[] | DatesRangeValue
  error: boolean
  handleChange: (date?: DateValue | Date[] | DatesRangeValue) => void
  handleBlur: (e: FocusEvent<HTMLButtonElement, Element>) => void
  minDate?: Date
  maxDate?: Date
  maxDateTooltip?: string
  excludeDate?: (date: Date) => boolean
  getDayProps?: (
    date: Date
  ) => Partial<Omit<DayProps, 'classNames' | 'styles' | 'vars'>>
  // Takes precedence over the built-in `maxDateTooltip` renderer.
  renderDay?: (date: Date) => ReactNode
  disabled?: boolean
  handleFieldClear?: VoidFunction
  withinPopup?: boolean
  rangePicker?: boolean
  /** Popover z-index. Defaults to 2000 — override when this picker can coexist on a page with a Modal (zIndex 1210), so the modal isn't visually covered by the calendar. */
  zIndex?: number
  formatDate: (date: Date) => string
  // Forwarded to the input so the picker works as a direct FormField child
  // (FormField injects data-testid onto its child; without a wrapper it'd be dropped).
  'data-testid'?: string
  colorTheme: Pick<
    ColorPalette,
    | 'primary'
    | 'info100'
    | 'white'
    | 'gray100'
    | 'gray600'
    | 'gray900'
    | 'black'
  >
}
